import * as _ from 'lodash-es'

interface MapKeysOptions {
  reverse?: boolean
}

/**
 * Maps keys in the given target object into those that are found in the given
 * map object. Optionally can reverse the mapping as well.
 */
export default function mapKeys<T extends Record<string, unknown>>(
  target: T,
  map: Record<string, string>,
  { reverse = false }: MapKeysOptions = {}
): Record<string, unknown> {
  return _.mapKeys(target, (_value, key) => {
    if (reverse === true) {
      const originalKey = Object.keys(map).find((mapKey) => map[mapKey] === key)

      return originalKey || key
    }

    return map[key] || key
  })
}
